import React from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteProperty = ({
    setIsDeleteProperty,
    selectedData,
    deletePropertyLoading,
    deletePropertyMutate,
    inventoryId
}) => {
    const handleDeleteSubmit = () => {
        deletePropertyMutate({ "inventoryId": inventoryId });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteProperty}
            title="Confirm Delete"
        >
            <WarningText>
                Are you sure you want to delete this inventory? This action cannot be undone
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteProperty(false)}
                >
                    Cancel
                </SideCancelBtn>
                <button
                    onClick={handleDeleteSubmit}
                    disabled={deletePropertyLoading}
                    className="rounded-md shadow-md  border border-rose-600 bg-white text-rose-600 hover:bg-rose-600 hover:text-white text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base"
                >
                    {deletePropertyLoading ? "Deleting..." : "Delete"}
                </button>
            </div>
        </Model>
    );
};
const WarningText = tw.p`text-gray-500 text-base mb-4`;
export default DeleteProperty;
